export { PRODUCT_FAMILY_SA as SA_PRODUCT_CODE } from './productFamily';
export const BUYER_SUBSCRIPTION_TYPE = 'BUYER';
export const SELLER_SUBSCRIPTION_TYPE = 'SELLER';
// SELLER_PAID is a DS (buyer-owned, seller-paid) subscription type. It shares the
// DS/buyer-side slot with BUYER; SELLER stays reserved for SA products.
export const SELLER_PAID_SUBSCRIPTION_TYPE = 'SELLER_PAID';

// DS/buyer-side subscription types (as opposed to the SA-side SELLER type).
export const DS_SUBSCRIPTION_TYPES = [
  BUYER_SUBSCRIPTION_TYPE,
  SELLER_PAID_SUBSCRIPTION_TYPE,
];

export const isDsSubscriptionType = type => DS_SUBSCRIPTION_TYPES.includes(type);

// Human-readable labels for display. Unknown values fall back to a simple
// title-case so nothing renders blank.
export const SUBSCRIPTION_TYPE_LABELS = {
  [BUYER_SUBSCRIPTION_TYPE]: 'Buyer',
  [SELLER_SUBSCRIPTION_TYPE]: 'Seller',
  [SELLER_PAID_SUBSCRIPTION_TYPE]: 'Seller Paid',
};

export const formatSubscriptionType = type => {
  if (!type) return '';
  return (
    SUBSCRIPTION_TYPE_LABELS[type]
    || type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()
  );
};

// Subscription-type options offered when creating a DS subscription.
export const DS_SUBSCRIPTION_TYPE_OPTIONS = [
  {
    key: BUYER_SUBSCRIPTION_TYPE,
    text: SUBSCRIPTION_TYPE_LABELS[BUYER_SUBSCRIPTION_TYPE],
    value: BUYER_SUBSCRIPTION_TYPE,
  },
  {
    key: SELLER_PAID_SUBSCRIPTION_TYPE,
    text: SUBSCRIPTION_TYPE_LABELS[SELLER_PAID_SUBSCRIPTION_TYPE],
    value: SELLER_PAID_SUBSCRIPTION_TYPE,
  },
];
